import { useState } from "react";
import { faqs } from "../../../mocks/home";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="sss" className="bg-background-100 py-16 md:py-24 scroll-mt-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="text-center">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            AKLINDAKİ NET SORULAR.
          </h2>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={i}
                className="bg-background-50 border border-background-200 rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
                >
                  <span className="font-semibold text-foreground-900">
                    {faq.q}
                  </span>
                  <i
                    className={`ri-add-line text-xl text-foreground-500 transition-transform ${
                      isOpen ? "rotate-45" : ""
                    }`}
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-6 pb-5 text-sm text-foreground-600 leading-relaxed animate-fade-in">
                    {faq.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}